export default [
	{
		path: 'manage-subscription/cancel-reason',
		name: 'manage-subscription-cancel-reason',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/CancelReason.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/try-again-in-the-future',
		name: 'manage-subscription-try-again-in-the-future',
		component: () =>
			import(
				/* webpackChunkName: "manage-subscription" */
				'@/views/account/manage-subscription/TryAgainInTheFuture.vue'
			),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/offer-creating',
		name: 'manage-subscription-offer-creating',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/OfferCreating.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/offer',
		name: 'manage-subscription-offer',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/offers/Offer.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/one-time-offer-reactivation',
		name: 'one-time-offer-reactivation',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/offers/Offer.vue'),
		props: {
			predefinedComponentName: 'OneTimeOfferForever',
		},
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},

	{
		path: 'manage-subscription/five-dollar-offer-forever',
		name: 'manage-subscription-five-dollar-offer-forever',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/offers/Offer.vue'),
		props: {
			predefinedComponentName: 'FiveDollarOfferForever',
		},
		meta: {
			hideHeader: true,
			requiresUser: true,
		},
	},

	{
		path: 'plan-management',
		name: 'plan-management',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PlanManagement.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/pause-subscription',
		name: 'pause-subscription',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PauseSubscription.vue'),
		meta: {
			requiresAuth: true,
			requiresUser: true,
			hideHeader: true,
		},
	},
	{
		path: 'plan-management-commitment',
		name: 'plan-management-commitment',
		component: () =>
			import(
				/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PlanManagementCommitment.vue'
			),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/cancellation-fee',
		name: 'plan-management-cancellation-fee',
		props: { scenarioId: 'cancellationFee' },
		component: () =>
			import(
				/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/cancellation/CancellationFee.vue'
			),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/switch-plan',
		name: 'plan-management-switch-plan',
		props: { scenarioId: 'switchPlan' },
		component: () =>
			import(
				/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/cancellation/CancellationFee.vue'
			),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},
	{
		path: 'plan-management/plan-actions',
		name: 'plan-management-plan-actions',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/PlanActions.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'CANCELLATION_OPTION_SCREEN',
				},
			},
		},
	},
	{
		path: 'plan-management/commitment-break-contract',
		name: 'plan-management-commitment-break-contract',
		component: () =>
			import(
				/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/CommitmentBreakContract.vue'
			),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'CANCEL_COMMITMENT_BREAK_CONTRACT_OPTIONS_SCREEN',
				},
			},
		},
	},
	{
		path: 'plan-management/reminder-success',
		name: 'plan-management-reminder-success',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/ReminderSuccess.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'CANCELLATION_REMINDER_ACTIVATED_SCREEN',
				},
			},
		},
	},
	{
		path: 'plan-management/warm-up-video',
		name: 'plan-management-warm-up-video',
		component: () =>
			import(/* webpackChunkName: "plan-management" */ '@/views/account/manage-subscription/WarmUpVideo.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
			pageAnalyticUxEvent: {
				name: 'ScreenView',
				data: {
					title: 'WARMUP_BEFORE_WINBACK_OFFER_SCREEN',
				},
			},
		},
	},
	{
		path: 'manage-subscription/rating',
		name: 'manage-subscription-rating',
		component: () =>
			import(/* webpackChunkName: "manage-subscription" */ '@/views/account/manage-subscription/RatingView.vue'),
		meta: {
			hideHeader: true,
			requiresAuth: true,
			requiresUser: true,
		},
	},
]
